import { useTranslation } from "react-i18next";
import styles from "./RoundSelector.module.css";

const getIndex = (groups, selectedGroupId) => {
	return groups.findIndex((group) => group.groupId === selectedGroupId);
};

const RoundSelector = ({ groups, selectedGroupId, setSelectedGroupId, activeGroupId }) => {
	const { t } = useTranslation();

	// Guard against empty groups array
	if (!groups || groups.length === 0) {
		return null;
	}

	const selectedIndex = getIndex(groups, selectedGroupId);
	const activeIndex = getIndex(groups, activeGroupId);

	// Handle navigation
	const handlePrevious = () => {
		if (selectedIndex > 0) {
			setSelectedGroupId(groups[selectedIndex - 1].groupId);
		}
	};

	const handleNext = () => {
		if (selectedIndex < activeIndex) {
			setSelectedGroupId(groups[selectedIndex + 1].groupId);
		}
	};

	// Determine if arrows should be active
	const isPreviousActive = selectedIndex > 0 && activeIndex > 0;
	const isNextActive = selectedIndex < activeIndex;

	// Get the current group
	const currentGroup = groups[selectedIndex] || groups[activeIndex];

	if (!currentGroup) {
		return null;
	}

	return (
		<div className={styles.roundSelector}>
			<button
				className={`${styles.arrow} ${styles.arrowLeft} ${!isPreviousActive ? styles.arrowInactive : ""}`}
				onClick={handlePrevious}
				disabled={!isPreviousActive}
				aria-label={t("predictions.roundSelector.previousRound")}
			>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>

			<div className={styles.groupDisplay}>
				<div className={styles.groupLabel}>{currentGroup.label}</div>
			</div>

			<button
				className={`${styles.arrow} ${styles.arrowRight} ${!isNextActive ? styles.arrowInactive : ""}`}
				onClick={handleNext}
				disabled={!isNextActive}
				aria-label={t("predictions.roundSelector.nextRound")}
			>
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>
		</div>
	);
};

export default RoundSelector;
